export const routerOFertas=[
{
    path:"/oferta-empleos",
    name:"oferta-empleo",
    component:()=>
        import(
            /* webpackChunkName: "" */ "../ofertasEmpleos.vue"
        )
}
]